<template>
  <div class="lineWrapper" :class="'mode_' + mode">
    <span v-if="$slots.title" class="name">
      <!-- @slot Left value of card-line -->
      <slot name="title" />
    </span>
    <span v-if="$slots.value" class="value">
      <!-- @slot Right value of card-line -->
      <slot name="value" />
    </span>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: 'row',
    },
  },
}
</script>

<style lang="scss" scoped>
.lineWrapper {
  font-size: rem(12px);
}

.name,
.value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @include flex-grow(1);
}

.name {
  text-align: left;
}

.value {
  font-weight: bold;
}

.mode {
  &_row {
    @include createFlex(flexbox, nowrap, row, space-between, center, center);

    .name {
      padding: 0 4px 0 0;
    }

    .value {
      padding: 0 0 0 4px;
      text-align: right;
    }
  }
  &_сolumn {
    @include createFlex(flexbox, nowrap, column, flex-start, stretch, stretch);

    .name {
      padding: 0 0 2px 0;
    }

    .value {
      overflow: hidden;
      text-align: left;
      text-overflow: unset;
      white-space: inherit;
    }
  }
}
</style>

<docs>
```vue
  <UiCardContentLine class="card_content_line">
    <span slot="title">Создание карты</span>
    <span slot="value">0,00 ₽</span>
  </UiCardContentLine>
```
</docs>
